import React from "react";

import { StyledP } from "./Message.styles";

const Message = ({ type, children }) => {
  return <StyledP $type={type}>{children}</StyledP>;
};

export default Message;
